
import {Navbar,LogoFarmasis} from "./Home.jsx"
import {mobile} from  "../services/services.js"
import logo2 from '../imgs/logosinfondo.png';
import {Outlet,useParams,NavLink} from 'react-router-dom'
import {useState,useEffect} from "react"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function Compartido(){
	
	
	let params=useParams();
	let {id}=params;
	const [value, setValue] = useState(0);
	

	
	const handleChange=(e,newValue)=>{ setValue(newValue)	};
	
	const [datos,setDatos]=useState({ID:"",Token:""});
    
	useEffect(()=>{
		if (datos.ID==="") { setDatos({ID:id})};
			
	 },[id,datos]);
	


	return(
		<div >
			<Navbar>		
						
				<LogoFarmasis src={logo2} alt="logocfc" />
			
				
				    <Tabs   value={value} onChange={handleChange} component={NavLink}  style={{ textDecoration: "none" }} textColor="secondary" indicatorColor="secondary" variant="scrollable"
  scrollButtons="auto" >
    					<Tab label="video-tutoriales" to={`/Compartido/Reproductor/${datos.ID}`} component={NavLink}  />
    					{mobile()?null:<Tab label="SPEED TEST" to="/Compartido/velocidad" component={NavLink} />}
    					<Tab label="consulta valides SUNAT"  to="/Compartido/ConsultaValidez" component={NavLink} />
    					<Tab label="Referidos" to="/Compartido/Referidos" component={NavLink} />
    				</Tabs>
       			
			</Navbar>
		<Outlet />   
		</div>
)}